import { useEffect, useState } from 'react'
import {FaqBanner, FaqSearch, FaqTabSection, FaqText, FaqTitle, GuideStartedContent, GuideStartedIcon, GuideStartedText, GuideStartedTitle, KnowledgeBase, KnowledgeSmallText, KnowledgeTitle, MainTabSection, MostRecent, SolutionTabSection, StartedText, StartedTitle, UserGuideSection, UserGuideStarted, UserGuideStartedItem, UserGuideStartedList, UserGuideStartedTitle } from './FaqStyle'
import { Breadcrumb, Container, Image, Tab, Tabs } from 'react-bootstrap'
import { MESSAGE } from '../../utils/message'
import CustomSearch from '../../components/common/customSearch'
import { useSelector, useDispatch } from 'react-redux'
import DocumentIcon from '../../assests/images/document-text.svg';
import { faqUserGuideHandler } from '../../redux/slices/faq/faqUserGuide-slice'
import { useLocation, useNavigate } from 'react-router-dom'

const FaqList = () => {
  const [searchValue, setSearchValue]= useState<string>('')
  const dispatch: any = useDispatch();
  const {state} = useLocation();
  const navigate = useNavigate();
  const faqUserGuideList = useSelector((state:any) => state?.faqUserGuide?.data)

  useEffect(() =>{
    dispatch(faqUserGuideHandler());
  },[])
  return (
    <>
      <FaqBanner>
        <Container className="cont-w">
          <FaqTitle>{MESSAGE.faqHelp}</FaqTitle>
          <FaqText>{MESSAGE.helpTagline}</FaqText>
        </Container>
      </FaqBanner>
      <MainTabSection className='main-tab-bg'>
        <Container className="cont-w">
            <FaqTabSection>
            <Tabs defaultActiveKey="solution" fill activeKey={"solution"}  onSelect={() => navigate(`/support/home`)}>
              <Tab eventKey="support_home" title="Support Home">
              </Tab>
              <Tab eventKey="solution" title="Solution">
                <FaqSearch>
                  <CustomSearch 
                    onSubmit={()=>{}}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    placeholder="Search GreatNonprofits Support Center..."
                  />
                </FaqSearch>
                <SolutionTabSection>
                  <KnowledgeBase>
                    <MostRecent>
                      <Breadcrumb>
                          <Breadcrumb.Item onClick={() => navigate('/support/home',{state:{activateTab:"solution"}})}> Solution</Breadcrumb.Item>
                          <Breadcrumb.Item active>{state?.faqType}</Breadcrumb.Item>
                         </Breadcrumb>
                      <KnowledgeTitle>{MESSAGE.knowledgeBase}</KnowledgeTitle>
                      <KnowledgeSmallText>{MESSAGE.quickGuide}</KnowledgeSmallText>

                        {/* --------------------------------List Of Question-------------------------------------- */}
                      
                      <UserGuideSection>
                      <UserGuideStartedTitle>{state?.faqType}</UserGuideStartedTitle>
                         <UserGuideStarted>
                              <StartedTitle>{state?.questionType}</StartedTitle>
                              <StartedText>{MESSAGE.faqInstruction}</StartedText>
                              <UserGuideStartedList>
                                {faqUserGuideList?.data?.map((guideList:any , _index:number ) => 
                                  guideList.questionList.map((faq:any, index:number) => (
                                    <UserGuideStartedItem key={index+1}>
                                    <GuideStartedIcon><Image src={DocumentIcon}/> </GuideStartedIcon>
                                        <GuideStartedText>
                                          <GuideStartedTitle onClick={() => navigate('/faq-detail',{state:{faqType:state?.faqType, questionType:state?.questionType}})}>{faq.question}</GuideStartedTitle>
                                          <GuideStartedContent>{faq.answer}</GuideStartedContent>
                                        </GuideStartedText>
                                    </UserGuideStartedItem>
                                  ))
                                )}
                                </UserGuideStartedList>
                         </UserGuideStarted>
                      </UserGuideSection>
                      </MostRecent>
                  </KnowledgeBase>
                </SolutionTabSection>
              </Tab>
            </Tabs>
            </FaqTabSection>
        </Container>
      </MainTabSection>
    </>
  )
}

export default FaqList
